// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1wNxJ","disabled":"FileBtn_disabled__3OYr4","warn":"FileBtn_warn__zwWip","fade":"FileBtn_fade__2lsDU"};